import { LitElement, html, Splide } from './-global.min.js'

export class HHPress extends LitElement {
  static properties = {
    slider: { state: true },
  }

  connectedCallback() {
    super.connectedCallback()
    const slider = this.querySelector('.splide')
    if (slider) {
      this.initSlider(slider)
    }
  }

  initSlider(slider) {
    this.slider = new Splide(slider, {
      type: 'loop',
      arrows: true,
      pagination: false,
      autoplay: false,
      useScroll: true,
    })

    const arrowEls = this.slider.root.querySelectorAll('.splide__arrow')

    arrowEls.forEach((el) => {
      el.addEventListener('click', () => {
        const { Autoplay } = this.slider.Components
        Autoplay.pause()
      })
    })

    this.slider.mount()
  }

  render() {
    return html`<slot></slot>`
  }
}

customElements.define('hh-press', HHPress)
